import { useNavigate } from "react-router-dom";
import { AdvertiserApi } from "../../utils/crud/adv_api";
import { falseableToEmptyString, makeStates, setStates } from "../../utils/hooks/makeStates";
import { useInfo } from "../../utils/hooks/useInfo";
import { useLanguageContext } from "../../context/LanguageContext";
import { makeHelpers } from "../../utils/EditProviderHelpers";
import { useEffectAsync } from "../../utils/hooks/useEffectAsync";
import { rethrow } from "../../utils/crud";
import { deleteFields, emptyArrayIfFalsable, floatOrDefault, inplaceObjectFilter, inplaceObjectMap, intOrDefault, trimNull } from "../../utils/object";
import { UserMessagesApi } from "../../utils/crud/user_message_api";

const { createContext, useContext } = require("react");

export const MessageEditContext = createContext();
export function useMessageEditContext() {
    return useContext(MessageEditContext)
}
const default_resource_state = {
    user_id: '',
    session_id: '',
    user_name: '',
    email: '',
    phone: '',
    message: '',
    created_at: '',
    is_read: false,
}
const default_secondary_state = {
    errors: {},
    loading: true,
}

const crud = new UserMessagesApi();
const resource_route = 'message'
function prepareToSet(key, value) {
    return value;
}
export const MessageProvider = ({ id, children }) => {
    const [resource_states, resource_setters] = makeStates(default_resource_state)
    const [secondary_state, secondary_setters] = makeStates(default_secondary_state);
    const navigate = useNavigate();
    const info = useInfo();
    const { t } = useLanguageContext();
    const { setLoading, setErrors } = secondary_setters;

    const pureFetch = async () => crud.find(id).then(rethrow);
    const fetchAndSet = (
        async () => pureFetch()
            .then((data) => {
                setStates(resource_setters, data, prepareToSet)
            })
            .catch((error) => {
                console.error(error);
                info(error?.code == 404 ? t('Resource not found') : t('Unknown error'), 'danger')
                navigate(`/messages`)
            })
    )
    const { setError } = makeHelpers(fetchAndSet, info, t, setErrors, navigate, resource_route)


    useEffectAsync(async () => {
        setStates(secondary_setters, default_secondary_state);
        if (!id) {
            setStates(resource_setters, default_resource_state);
        }
        if (id) {
            await fetchAndSet();
        }
        setLoading(false)
    }, [id]);

    let all_states = {
        ...resource_states,
        ...resource_setters,
        ...secondary_state,
        ...secondary_setters,
        setError
    }
    return <MessageEditContext.Provider value={{ ...all_states }}>
        {children}
    </MessageEditContext.Provider>

}